"use client";
import React, { useEffect, useState } from "react";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";
import { filterCateImg } from "@/components/Home2/Collection";
import { defaultLocale } from "@/config";
import { useChannel } from "@/context/channel";
import { Button } from "../Button";
import { Placeholder } from "../Placeholder";
import HoverIcon from "./HoverIcon";
import Price from "@/components/Price/price";
import { useShoppingCart } from "@/lib/hooks/useShoppingCart";
import { useShoppingCartStore } from "@/lib/store/shoppingCart";
import { useRouter } from "@/navigation";
import clsx from "clsx";
import { useLoveStore } from "@/lib/store/love.store";

type dscObj = {
	data: { text: string };
	type: string;
};
type dscList = {
	blocks: dscObj[];
};
export const filterSortDsc = (dsc: string) => {
	let sortDsc = "";
	let longDsc = "";
	if (dsc) {
		const dscObj = JSON.parse(dsc) as dscList;

		if (dscObj && dscObj.blocks.length > 0) {
			sortDsc = dscObj.blocks[1].data.text;
			longDsc = dscObj.blocks[0].data.text;
		}
	}

	return { sortDsc, longDsc };
};
export default function ProductCard({ productItem, locale, haveButton = "true" }) {
	const t = useTranslations();
	const router = useRouter();
	const { channel: saleorChannel } = useChannel(locale);

	const { addToCart, createBuyBowCheckout } = useShoppingCart();
	const { setisCart } = useShoppingCartStore() as any;
	// state
	const [VariantActive, setVariantActive] = useState<any>(productItem.variants[0]);
	const [Variant, setVariant] = useState<any>(productItem.variants[0]);
	const [loading, setLoading] = useState(false);
	const productName =
		locale === defaultLocale ? productItem.name : productItem.translation?.name || productItem.name;
	const productImages = filterCateImg(productItem.metadata);
	const productImage = productImages[1]?.url || productImages[0]?.url || "/image/default-image.webp";
	const visibleVariants = productItem.variants?.slice(0, 4) ?? [];
	const remainingVariantCount = Math.max((productItem.variants?.length ?? 0) - visibleVariants.length, 0);

	const handlerAttribute = (item: any) => {
		setVariantActive(item);
		setVariant(item);
	};

	async function AddCart() {
		// if (!isLogin()) {
		// 	setOpenLoginModal(true);
		// 	message.error("NOT Login");
		// 	const login = document.querySelector("#web-login") as HTMLLIElement;
		// 	return login.click();
		// }
		if (!VariantActive) return;
		setLoading(true);
		// @ts-ignore
		await addToCart({
			channel: saleorChannel,
			selectedVariantID: VariantActive.id,
			quantity: 1,
		});
		return setLoading(false);
	}
	async function BuyBow() {
		// if (!isLogin()) {
		// 	setOpenLoginModal(true);
		// 	message.error("NOT Login");
		// 	const login = document.querySelector("#web-login") as HTMLLIElement;
		// 	return login.click();
		// }
		if (!VariantActive) return;
		setLoading(true);
		// @ts-ignore
		await createBuyBowCheckout({
			channel: saleorChannel,
			selectedVariantID: VariantActive.id,
			quantity: 1,
		});
		setLoading(false);
		setisCart(false);
		router.push("/checkout");
	}
	return (
		<div className="group relative flex h-full w-full flex-col overflow-hidden rounded-xl border border-neutral-200 bg-white transition-shadow duration-300 hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)]">
			<HoverIcon AddCart={AddCart} BuyBow={BuyBow} product={productItem} />
			<div className="relative flex aspect-square items-center justify-center overflow-hidden bg-neutral-50 p-6">
				{loading && (
					<div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70">
						<div className="h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-black"></div>
					</div>
				)}
				<Link
					href={"/product/" + productItem.slug}
					className="relative z-[1] flex h-full w-full items-center justify-center"
				>
					<Placeholder
						alt={productName}
						src={productImage}
						quality={60}
						imageHeight={300}
						imageWidth={300}
						fit="contain"
						className="mx-auto transition-transform duration-500 ease-out group-hover:scale-[1.03]"
					/>
				</Link>
			</div>
			<div className="flex flex-1 flex-col p-4">
				<Link href={`/product/${productItem.slug}`}>
					<h3 className="line-clamp-2 min-h-[44px] text-[15px] font-medium leading-snug text-black transition-colors duration-200 hover:text-neutral-600">
						{productName}
					</h3>
				</Link>
				<div className="mt-2 flex items-center justify-between gap-3">
					<p className="text-[17px] font-semibold text-black">
						<Price
							price={Variant?.pricing?.price.gross.amount || ""}
							currency={Variant?.pricing?.price.gross.currency}
						/>
					</p>
					<span className="shrink-0 rounded bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-600">
						{t("common.inStock")}
					</span>
				</div>
				{haveButton === "true" && (
					<Link href={`/product/${productItem.slug}`} className="mt-4 block">
						<Button
							size="xs"
							className="w-full !rounded-lg border border-neutral-200 bg-black !px-4 !py-2.5 text-[13px] font-medium !text-white transition-colors duration-200 hover:!bg-neutral-800"
						>
							{t("base.viewMore")}
						</Button>
					</Link>
				)}
				<div className="mt-3 flex flex-wrap items-center gap-1.5">
					{visibleVariants.length > 0 &&
						visibleVariants.map((item: any) => (
							<button
								type="button"
								className={`h-6 rounded-md border px-2 text-[11px] font-medium transition-colors duration-150 ${
									item == VariantActive
										? "border-black bg-black text-white"
										: "border-neutral-200 bg-white text-neutral-500 hover:border-neutral-400 hover:text-black"
								}`}
								key={item.name}
								onClick={() => handlerAttribute(item)}
							>
								{item.name}
							</button>
						))}
					{remainingVariantCount > 0 && (
						<span className="h-6 rounded-md border border-neutral-200 px-2 pt-[3px] text-[11px] font-medium text-neutral-400">
							+{remainingVariantCount}
						</span>
					)}
				</div>
			</div>
		</div>
	);
}
export function IconLove(props: { product?: any }) {
	let product = props.product;

	const [isLove, setIsLove] = useState(false);
	const { loveIds, setLoveProducts } = useLoveStore();
	const t = useTranslations();

	// console.log(loveIds,'product');
	useEffect(() => {
		if (loveIds.length && product?.id) {
			setIsLove(loveIds.includes(product.id));
		} else {
			setIsLove(false);
		}
	}, [loveIds]);
	const addOrDelLike = (event: React.MouseEvent) => {
		event.stopPropagation(); //
		const id = product?.id;
		if (id) {
			setLoveProducts(id);
		}
	};
	return (
		<i
			onClick={addOrDelLike}
			className={clsx(
				"text-xl text-[#000]",
				isLove ? "ri-heart-fill !text-[#d53a3d]" : "ri-heart-line !text-[#000]",
			)}
		></i>
	);
}
